import { HttpErrorResponse } from '@angular/common/http';

export enum ApiErrorCode {
    EBADREQ = 'EBADREQ',
    ENOTVALID = 'ENOTVALID',
    ENOMEDIA = 'ENOMEDIA',
    ENOCLIENT = 'ENOCLIENT',
    EJSONINV = 'EJSONINV',
    EPARAMINV = 'EPARAMINV',
    ENORIGHT = 'ENORIGHT',
    EDUPLICATE = 'EDUPLICATE',
    ECONFL = 'ECONFL',
    FIELD_DEFINITIONS_SUBACTION_NOT_ALLOWED = 'FIELD-DEFINITIONS-SUBACTION-NOT-ALLOWED',
    FIELD_DEFINITIONS_PROCESSING = 'FIELD-DEFINITIONS-PROCESSING',
    STORAGE_POOL_NOT_FOUND = 'STORAGE-POOL-NOT-FOUND',
    INVALID_SPEL_EXPRESSION = 'INVALID-SPEL-EXPRESSION',
    INVALID_SERVER_URL = 'INVALID-SERVER-URL'
}

export interface ApiError {
    Code: string;
    Message: string;
    Status: number;
    ExistingRecordIds?: string[];
}

export interface MediaHavenHttpErrorResponse extends HttpErrorResponse {
    error: ApiError;
}

export interface ApiValiditionError extends ApiError {
    Code: ApiErrorCode.ENOTVALID;
    Errors: ApiFieldError[];
}

export interface ApiFieldError {
    Field?: string;
    Message: string;
    Type: string;
}
